import React from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Tabs, Typography } from "antd";
import { TagOutlined, UnorderedListOutlined, RiseOutlined, FileTextOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const CouponLayout = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const getActiveKey = () => {
        if (location.pathname.includes("list")) return "list";
        if (location.pathname.includes("usage")) return "usage";
        if (location.pathname.includes("create")) return "create";
        if (location.pathname.includes("edit")) return "edit";
        if (location.pathname.includes("details")) return "details";
        return "list";
    };

    const handleTabChange = (key) => {
        navigate(`/admin/coupons/${key}`);
    };

    return (
        <div className="sd-container" style={{ padding: '24px' }}>
            {/* Header Section */}
            <div style={{ marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '16px' }}>
                <div style={{ 
                    width: '56px', height: '56px', background: '#fff', 
                    borderRadius: '12px', display: 'flex', alignItems: 'center', 
                    justifyContent: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' 
                }}>
                    <TagOutlined style={{ fontSize: '24px', color: '#1890ff' }} />
                </div>
                <div>
                    <Title level={4} style={{ margin: 0, fontWeight: 800 }}>Coupon Management</Title>
                    <Text type="secondary" style={{ fontWeight: 500, fontSize: '12px' }}>
                        Manage promotional campaigns, validate codes, and track usage.
                    </Text>
                </div>
            </div>

            {/* Navigation Tabs */}
            <Tabs 
                activeKey={getActiveKey()} 
                onChange={handleTabChange}
                size="large"
                tabBarStyle={{ fontWeight: 600, color: '#64748b' }}
                items={[
                    { label: <span><UnorderedListOutlined /> All Coupons</span>, key: 'list' },
                    { label: <span><FileTextOutlined /> Usage History</span>, key: 'usage' }
                ]}
            />

            {/* Render nested routes (Dashboard, List, Create, Edit, Details) */}
            <div style={{ marginTop: '16px' }}>
                <Outlet />
            </div>
        </div>
    );
};

export default CouponLayout;
